import { Button, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Add } from "../../../../../assets/icons/Add";
import { IControls } from "../../../../../utils/interfaces";
import { SearchField } from "../../../../common/SearchField/SearchField";
import classes from "./PatientsControls.module.scss";

export const PatientsControls = ({ updateSearchParams }: IControls) => {
  const navigate = useNavigate();

  return (
    <div className={classes.controlsContainer}>
      <h1>Patients</h1>
      <div className={classes.controls}>
        <SearchField
          className={classes.searchInput}
          updateSearchParams={updateSearchParams}
          placeholder="Quick search for anything"
        />
        <Divider flexItem orientation="vertical" />
        <Button
          className={classes.addPatient}
          onClick={() => navigate("/patients/create")}
          startIcon={<Add />}
          variant="contained"
        >
          Add Patient
        </Button>
      </div>
    </div>
  );
};
